import axios from 'axios';
import { domain } from '../config/proxy';
// import Vue from 'vue';
import router from '../router';
import * as FN from '@/public';
// const that = new Vue();

// 其它错误状态码 除401 100 200
let fn = ({ msg = "网络错误", message = "网络错误" }) => FN.LoginTips({ content: msg || message || "未登录，请登录" });

// 避免其它状态码影响401弹窗,所以需要用两个分开处理

// 开启防抖避免重复提示
let debounce = FN.debounce(fn, 3000);

// 对其它code状态提示进行节流
// let throttle = FN.throttle(fn, 5000);

axios.defaults.baseURL = domain;
axios.defaults.timeout = 250000;

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  let { url = null } = config
  // 判断该接口是否需要登录才能调用
  if (FN.verify(url)) return false;

  // 判断该接口是否需要权限才能调用
  // if (FN.interfaceManagement(url)) {
  //   debounce({ msg: "无权限,请联系管理员userservice@sunther.com" });
  //   return false;
  // };
  config.headers.Platform = `PES`;
  let oldUrlData = ["/api/translate-client/open/transOrderPageList", "/api/translate-client/open/uploadFileList", "/api/translate-client/open/saveTransOrder"];
  // 模块的走这个新token
  let newTokenList = ["updatePass", "open", "tran", "infomation", "gmi", "manage", "system", "collection_list"];
  let { token = null, Authorization = null, } = config.headers;
  // 这个接口走老模块
  let [cigUrl] = url.split("?");
  if (oldUrlData.find(item => item === cigUrl)) {
    // 非模块走老pes token
    if (FN.getLC(FN.tokenName)) {
      !token && (config.headers.token = `Bearer ${FN.getLC(FN.tokenName)}`);
      !Authorization && (config.headers.Authorization = `Bearer ${FN.getLC(FN.tokenName)}`);
    };
  } else {
    let urlList = config.url.split("/");
    if (newTokenList.find(item => urlList.find(a => a === item))) {
      // if (newTokenList.find(item => urlList.find(a => a === item))) {
      !token && (config.headers.token = FN.check(FN.getUser(), 'newToken'));
      !Authorization && (config.headers.Authorization = FN.check(FN.getUser(), 'newToken'));
    } else {
      // 非模块走老pes token
      if (FN.getLC(FN.tokenName)) {
        !token && (config.headers.token = `Bearer ${FN.getLC(FN.tokenName)}`);
        !Authorization && (config.headers.Authorization = `Bearer ${FN.getLC(FN.tokenName)}`);
      };
    };
  };
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  let responseType = FN.dataType(response.data);
  // 流媒体数据不需要处理
  switch (responseType) {
    case "Object": return normal(response); //普通接口处理
    case "Blob": return response; //流媒体接口处理
    default: return normal(response);
  }
}, function (error) {
  return Promise.reject(error);
});

// 普通接口处理
let normal = response => {
  let { data = {} } = response;
  let { code = 100 } = data;
  // 200 和 100 都算成功 直接返回数据
  if ((code != 100) && (code != 200)) {
    // 避免重复提示
    if (FN.getUser()) {
      switch (code) {
        // 处理无权限300
        case 300: return debounce({ msg: "无权限,请联系管理员userservice@sunther.com!" }, true);
        // FN.Tips(false, { content: "无权限,请联系管理员userservice@sunther.com" });
        // 处理401 token过期
        case 401: return FN.logout(null).then(a => {
          if (a) {
            router.$push('/home');
            debounce({ msg: "登录状态过期,请重新登录！" }, true);
            FN.getRoles();
          }
        }); //处理登录状态过期
        // 处理其它错误
        // default: throttle(data); break;
      };
    } else {
      // 没有登录的情况
      switch (code) {
        // 处理无权限300
        case 300: return debounce({ msg: "未登录，请登录" });
        // 未登录情况的401接口抛出
        case 401: return debounce({ msg: "未登录，请登录" }, true);
        // 处理其它错误
        // default: throttle(data); break;
      };
    };
  };
  return data;
};

export default axios;